import GTM from '../../gtm/GTM';
import GTMLoginModel from '../../gtm/models/GTMLoginModel';

export default abstract class TrackLogin {
    public static trackLoginEvent(): void {
        if (!this.#isLoginEventFinished()) {
            return;
        }

        GTM.track(GTMLoginModel.parseToGTMData());
    }

    static #isLoginEventFinished(): boolean {
        const meta = document.querySelector<HTMLMetaElement>('meta[name="login_method"]');

        return Boolean(meta?.getAttribute('content'));
    }
}
